import React, { useEffect, useRef } from "react";
import styles from "./Modals.module.css";
import Close from "Utils/Assets/SVGs/Close";
import { ICreateEditDepartmentModalProps } from "@model/Department.model";
import CreateOrEditDepartmentModalForm from "../Forms/CreateOrEditDepartmentModalForm";

const CreateEditDepartmentModal: React.FC<ICreateEditDepartmentModalProps> = ({
  open,
  onClose,
  forEdit = false,
  department,
  onSuccess,
}) => {
  const dialogRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => dialogRef.current?.focus(), 0);
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={styles.mcdBackdrop}
      role="presentation"
      onMouseDown={onClose}
      data-testid="create-dept-backdrop"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="cdm-title"
        className={styles.mcdModal}
        onMouseDown={(e) => e.stopPropagation()}
        tabIndex={-1}
        ref={dialogRef}
        data-testid="create-dept-modal"
      >
        <header className={styles.mcdHead}>
          <h2 id="cdm-title" className={styles.mcdTitle}>
            {forEdit ? "Edit Department" : "Create Department"}
          </h2>
          <button
            type="button"
            className={styles.mcdIconBtn}
            onClick={onClose}
            aria-label="Close"
            data-testid="create-dept-close"
          >
            <Close className={styles.mcdCloseIcon} />
          </button>
        </header>

        <CreateOrEditDepartmentModalForm
          onClose={onClose}
          forEdit={forEdit}
          initialDepartment={department ?? null}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  );
};

export default CreateEditDepartmentModal;
